module.exports = __webpack_public_path__ + "img/icon_logo_piano_232.d9d3bf45.png";